<div class="calendario-redesign flex-direction-column">
  <div class="calendario-cabecalho flex-direction-row justify-between align-center">
    <button type="button" class="calendario-nav" aria-label="Anterior" (click)="navAnterior()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button type="button" class="calendario-titulo-btn" (click)="alternarVisualizacao()">
      <span class="calendario-titulo">{{ visualizacao() === 'dias' ? tituloMes : tituloAnos }}</span>
    </button>
    <button type="button" class="calendario-nav" aria-label="Próximo" (click)="navProximo()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  @if (visualizacao() === 'dias') {
    <div class="calendario-semana">
      @for (dia of diasSemana; track $index) {
        <span class="calendario-semana-dia">{{ dia }}</span>
      }
    </div>

    <div class="calendario-grade">
      @for (dia of dias; track dia.data.valueOf()) {
        <button type="button" class="calendario-dia"
                [class.calendario-dia-fora]="dia.foraDoMes"
                [class.calendario-dia-hoje]="ehHoje(dia)"
                [class.calendario-dia-selecionado]="ehSelecionado(dia)"
                [disabled]="dia.desabilitado"
                (click)="selecionarDia(dia)">
          {{ dia.numero }}
        </button>
      }
    </div>
  } @else {
    <div class="calendario-grade-anos">
      @for (ano of anosGrade; track ano) {
        <button type="button" class="calendario-ano"
                [class.calendario-ano-selecionado]="ano === mesAtual.year()"
                (click)="selecionarAno(ano)">
          {{ ano }}
        </button>
      }
    </div>
  }
</div>
